import { LandingPlayground } from './LandingPlayground';

export const Learning = {
  LandingPlayground,
};
